<template>
    <div>
        <div class="col-12 d-flex justify-content-end">
            <b-button v-b-toggle.collapse-1 variant="outline-care" @click="onToggle" class="pull-right pill">
                {{this.text}} <b-icon v-bind:icon="this.icon" variant="care-dark" scale="1.3" class="pt-1" ></b-icon>
            </b-button>
        </div>

        <b-collapse id="collapse-1" class="mt-2">
            <compact-module
                    :introduction="module.introduction"
                    :competences="module.competences"
                    :missions="module.missions"
                    :key="module.id"
            />
        </b-collapse>
    </div>

</template>

<script>
    import CompactModule from "./CompactModule";

    export default {
        components: {CompactModule},
        props:{
            module: Object
        },
        data(){
            return{
                open: false,
                openText: trans.courses.new_dashboard.open_optional,
                closeText: trans.courses.new_dashboard.close_optional,
                text: trans.courses.new_dashboard.open_optional,
                icon: 'chevron-right'
            }
        },
        methods:{
            onToggle(){
                this.open = !this.open;
                if(this.open === true){
                    this.text = this.closeText;
                    this.icon = 'chevron-down'
                }
                else{
                    this.text = this.openText;
                    this.icon = 'chevron-right'
                }
            }
        }
    }
</script>

<style scoped>
    .pill{
        border-radius: 30px !important;
    }
</style>